<template>
  <div class="ctn">
    <div class="left">
      <div class="desc" @mouseenter="enhanceBtn = true" @mouseleave="enhanceBtn = false"> {{hotKey.desc}} </div>
      <el-tooltip v-if="customizable" effect="light" content="添加组合键" placement="top">
        <div v-if="customizable" class="el-icon-plus edit-btn" :class="{'btn-enhance': enhanceBtn}" @click.stop="addComboHandler" />
      </el-tooltip>
    </div>

    <div class="key">
      <hot-key-btn 
        v-for="t in texts" 
        :key="t.id" 
        :text="t" 
        :customizable="customizable"
        @editing="editingHandler" 
        @deleteHotKey="deleteHotKeyHandler"
        @updateHotKey="updateHotKeyHandler" 
      />
    </div>
  </div>
</template>

<script>
import HotKeyBtn from "./hotKeyBtn";
export default {
  name: "hotKeyItem",
  components: {HotKeyBtn},
  props: ["hotKey", "customizable"],
  data() {
    return {
      enhanceBtn: false,
      newCombo: undefined,
    }
  },
  computed: {
    texts: function() {
      let hkt = this.hotKey.getTexts()
      if (this.newCombo !== undefined) hkt.push(this.newCombo)
      return hkt
    }
  },
  methods: {
    refresh() {
      this.$emit("refresh")
    },
    editingHandler: function(isEditing) {
      // console.log("hotKeyItem editing")
      this.$emit("editing", isEditing)
    },
    // updateHotKeyHandler(oldCombo, newCombo)
    updateHotKeyHandler: function(oldCombo, newCombo) {
      console.log(`hotKeyItem saveHotKeyHandler: keyName: ${this.hotKey.name}, oldCombo: ${oldCombo}, newCombo: ${newCombo}`)

      // 新增的组合键
      if (oldCombo === "") {
        this.newCombo = undefined
        this.addHotKey(newCombo)
        return
      }

      // 要更新的组合键
      let self = this
      this.utils.hotKey.updateComboAndSave(this.hotKey.name, oldCombo, newCombo, 
        (error, data, response) => { self.api.errHandler(self, error, response) }, 
        () => {
          self.$message.success("设置快捷键成功")
          self.refresh()
        }
      )
      console.log("updateHotKeyHandler: this.utils.hotKey.GlobalHotKey:", this.utils.hotKey.GlobalHotKey)
    },
    deleteHotKeyHandler(combo) {
      console.log("hotKeyItem: delete hotkey: combo:", combo)
      let self = this
      this.utils.hotKey.deleteComboAndSave(this.hotKey.name, combo, 
        (error, data, response) => { self.api.errHandler(self, error, response) }, 
        () => {
          self.$message.success("删除快捷键成功")
          self.refresh()
        }
      )
      console.log("updateHotKeyHandler: this.utils.hotKey.GlobalHotKey:", this.utils.hotKey.GlobalHotKey)
    },
    addComboHandler() {
      console.log("addComboHandler")
      this.newCombo = ""
    },
    addHotKey(combo) {
      console.log("addHotKey: combo:", combo)
      let self = this
      this.utils.hotKey.addComboAndSave(this.hotKey.name, combo, 
        (error, data, response) => { self.api.errHandler(self, error, response) }, 
        () => {
          self.$message.success("添加组合键成功")
          self.refresh()
        }
      )
      console.log("updateHotKeyHandler: this.utils.hotKey.GlobalHotKey:", this.utils.hotKey.GlobalHotKey)
    },
  },
}
</script>

<style scoped>
.ctn {
  display: flex;
  justify-content: space-between;
  /*align-items: center;*/
  /*line-height: 1.8em;*/
}
.left {
  display: flex;
  /* flex-wrap: nowrap; */
  justify-content: baseline;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.desc {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.key {
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.edit-btn {
  color: rgba(0, 0, 0, 0.16);
  min-width: 19px;
  height: 19px;
  line-height: 19px;
  cursor: pointer;
  border-radius: 3px;
}
.edit-btn:hover {
  color: #000;
  background-color: rgba(0, 0, 0, 0.08);
}
.edit-btn:active {
  color: #000;
  background-color: rgba(0, 0, 0, 0.16);
}

.btn-enhance {
  color: #000;
}
</style>
